function generateFeeScheduleOptionsErrors({
  response,
  employeeId,
  networkId,
  contactId,
}) {
  const errorData = {
    response,
    employeeId,
    networkId,
    contactId,
  };

  window.datadogLogs.logger.error('Unable to reach fee schedules endpoint', errorData);
}

export default generateFeeScheduleOptionsErrors;
